import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { Employer } from './employer.interface';

export interface EmployerServiceInterface {
   getEmployers: (query?: LocationQuery) => Promise<PaginatedResponse<Employer>>;
   getEmployer: (employerId: number, query?: LocationQuery) => Promise<Employer>;
   postEmployer: (employer: Employer) => Promise<Employer>;
   putEmployer: (employerId: number, employer: Employer) => Promise<Employer>;
   patchEmployer: (employerId: number, patchBody: Employer) => Promise<Employer>;
}

export class EmployerService implements EmployerServiceInterface {
   async getEmployers(query?: LocationQuery) {
      return http.get<PaginatedResponse<Employer>>(`/employers`, { params: { ...query } }).then((response) => response.data);
   }
   async getEmployer(employerId: number, query?: LocationQuery) {
      return http.get<Employer>(`/employers/${employerId}`, { params: { ...query } }).then((response) => response.data);
   }
   async postEmployer(employer: Employer) {
      return http.post<Employer>(`/employers/`, employer, { params: { append: 'scopes' } }).then((response) => response.data);
   }
   async putEmployer(employerId: number, employer: Employer) {
      return http.put<Employer>(`/employers/${employerId}`, employer, { params: { append: 'scopes' } }).then((response) => response.data);
   }
   async patchEmployer(employerId: number, patchBody: Employer) {
      return http
         .patch<Employer>(`/employers/${employerId}`, patchBody, { params: { append: 'scopes' } })
         .then((response) => response.data);
   }
   async uploadSignature(employerId: number, file: File) {
      const formData = new FormData();
      formData.append('signature', file);

      return await http.post(`/employers/${employerId}/signature`, formData).then((response) => response.data);
   }

   async uploadLogo(employerId: number, logo: string): Promise<{ path: string }> {
      const formData = new FormData();
      formData.append('logo', logo);

      return await http.post(`/employers/${employerId}/logo`, formData).then((response) => response.data);
   }
}
